import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { base64ToFile, ImageCroppedEvent } from 'ngx-image-cropper';
import { OnboardingService } from '../../onboarding.service';

@Component({
  selector: 'app-treasury-form',
  templateUrl: './treasury-form-dialog.component.html',
  styleUrls: ['./treasury-form-dialog.component.scss']
})
export class TreasuryFormComponent implements OnInit {
  // form: FormGroup;
  treasuryForm!: FormGroup;
  submitted = false;
  errMessage: string = '';
  showErrMsg: boolean = false;
  imgChangeEvt: any = '';
  cropImgPreview: any = '';

  croppedImage: any;
  stopCropper: boolean = true;
  imageBoxDisable: boolean = true;
  imageFlag: boolean = false;
  iconDisabled: boolean = true;
  cropButton: boolean = false;
  imageText: any;
  // originalFile: any;
  files: File;
  imgFile: File;
  finalImage: any;
  originalFile: any;
  cropImgButton: boolean = true;
  clickedCrop: boolean = false;
  titleText: any;
  descriptionText: any;
  linkText: any;
  urlRegEx =/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&\(\)\*\+,;=.]+$/;
  croppedFile:any;
  @Input() treasuryDetails: any;
  @ViewChild('progressDialog', { static: true }) secondDialog: TemplateRef<any>;
  isEdit:boolean=false;
  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    private onboardingService: OnboardingService,
    public dialogRef: MatDialogRef<TreasuryFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
    this.treasuryForm = this.formBuilder.group({
      art: ['', Validators.required],
      title: ['', Validators.required],
      description: ['', Validators.required],
      link: ['',Validators.compose([Validators.required, Validators.pattern(this.urlRegEx)])]

    });
    document.getElementById("fileupload").addEventListener("cancel", (evt) => {
      console.log("You closed the file picker dialog without selecting a file.");
      this.cropButton=false;
      this.croppedImage = this.data?.croppedImage ? this.data.croppedImage :  this.data.treasuryImageUrl;
        this.stopCropper = false;
    });
    console.log(this.data)
    if (this.data) {
      setTimeout(() => {
        this.treasuryForm.setValue({
          art: this.data?.treasuryName,
          title: this.data?.treasuryTitle,
          description: this.data?.treasuryDesc,
          link: this.data?.treasuryExpThis
        })
        this.isEdit=true;
        this.croppedImage = this.data?.croppedImage ? this.data.croppedImage :  this.data.treasuryImageUrl;
        this.stopCropper = false;
      }, 1000)

    }
  }

  get loginFormControl() {
    return this.treasuryForm.controls;
  }
  onFileChange(event: any): void {
    this.imgChangeEvt = event;
    this.stopCropper = true;
    this.imageFlag = true;
    this.iconDisabled = false;
    this.originalFile = event.target.files[0];
    if (event.target.files[0].size >= 41943040) {
      console.log(event.target.files[0].size)
      this.imageFlag = false;
      this.imgChangeEvt = '';
      this.iconDisabled = true;
      this.clickedCrop = true;
    }
    else {

    }
  }
  click() {
    this.stopCropper = true;
    this.cropButton = true;
  }
  imageCropped(event: ImageCroppedEvent, file: any) {

    console.log(file, event)
    this.cropImgPreview = event.base64;
    this.croppedImage = this.cropImgPreview;
    console.log(this.croppedImage)
    const file1 = new File([base64ToFile(this.croppedImage)],
      this.originalFile.name, {
      lastModified: this.originalFile.lastModified,
      type: this.originalFile.type

    });
    console.log(file1)
    this.croppedFile = file1
  }

  imgLoad() {
    // display cropper tool
  }
  initCropper() {
    // init cropper
  }

  imgFailed() {
    // error msg
  }
  cropImage(file: any) {
    this.cropImgButton = false;
    this.stopCropper = false;
    this.imageBoxDisable = false
    this.cropButton = false;
  }

  onSubmit() {
    console.log(this.descriptionText && this.titleText && this.croppedImage && this.linkText)
    if(this.treasuryForm.valid){
   this.dialog.open(this.secondDialog, { disableClose: true });
      let finalObject: any = {
        treasuryName: this.treasuryForm.value.art,
        treasuryTitle: this.treasuryForm.value.title,
        treasuryDesc: this.treasuryForm.value.description,
        expThisLink: this.treasuryForm.value.link ?  this.treasuryForm.value.link : null,
        imageRotationDegrees: '90'

      }
      if(this.data?.id){
        finalObject['updatedTreasuryId'] = this.data.id
      }
      console.log(this.treasuryForm.value);;
      this.onboardingService.getShowcases().subscribe((res: any) => {
        console.log(res)
        finalObject['userId']=res.user;
        this.onboardingService.postSetup3(this.croppedFile, res.user, finalObject).subscribe((response) => {
          console.log(response)
          this.treasuryForm.reset()
          this.dialog.closeAll()
          this.dialogRef.close()
        }, err => {

        })
      })
    }


  }
}
